// extracted by mini-css-extract-plugin
module.exports = {"product-wrapper":"_8cHXPCK9qEO6vOZkcIXae","info-wrapper":"_24zdPDElI_I5Ll5FbntLP8","why-capital":"_25dYh5al9ASDveAfRiiKa1","more-questions":"_22IauajpEAOV-IUrt2G0QX"};